import { Season } from './../../models';
import { AuthService } from './../../service/auth.service';
import { Component, OnInit ,ViewContainerRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import 'rxjs/add/operator/map';
import { EcomicService } from '../../service/comics/ecomic.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
@Component({
  selector: 'app-e-comic-season-add',
  templateUrl: './e-comic-season-add.component.html',
  styleUrls: ['./e-comic-season-add.component.css']
})
export class EComicSeasonAddComponent implements OnInit {
  comicseasonForm: FormGroup;
  loading: boolean = false;
  load: boolean = false;
  comics: any;
  showseries: any = false;
  id: any;
  status: any = true;
  season: any = true;
  user: any;
  quater: any = true;

  thumbnail_image: File;
  cover_image: File;
  sponsor_image: File;
  thumbnail_image_url: any;
  cover_image_url: any;
  sponsor_image_url: any;
  coverimageerror: any = false;
  thumbnailimageerror: any = false;
  sponsorimageerror: any = false;
  sponsorimageerror_Web:any = false;
  sponsor_image_web: File;
  sponsor_image_url_web: any;

  constructor(private form: FormBuilder, private router: Router, private auth: AuthService,
    private afs: AngularFirestore, private comicService: EcomicService, private route: ActivatedRoute ,
     public toastr: ToastsManager,vcr: ViewContainerRef  ) {
    this.toastr.setRootViewContainerRef(vcr);
   }

  ngOnInit() {
    this.comicseasonForm = this.form.group({
      comic_series: ['', [Validators.required]],
      season_title: ['', [Validators.required]],
      season_description: ['', [Validators.required]],
      author_name: ['', [Validators.required]],
      about_author: ['', [Validators.required]],
      IsAllowPointsPurchase:["false",[]],
      thumbnail: ['', []],
      season_cover: ['', []],
      sponsor_logo: ['', []],
      sponsor_url: ['', [Validators.required]],
      status: ['InActive', [Validators.required]],
      season: ['Season 1', [Validators.required]],
      season_quarter: ['1', [Validators.required]],
      on_going_series:['false', [Validators.required]],
   
    });
    // getting the available eseries from the database
    this.comicService.getserious().then(comsicsdata => {
      // subscribing the data from the service
      comsicsdata.subscribe(comics => {
        this.comics = comics;
        if (this.route.firstChild) {
          this.route.firstChild.params.subscribe(params => {
            this.id = params['id'];
            if (this.id) {
              this.status = false;
              this.season = false;
              this.quater  = false;
              this.comicService.getsinglecomic(this.id, 'Ecomicseason').then(data => {
                // const admindata = data.valueChanges();
                data.subscribe(singleseries => {
                  const singleadmin = singleseries;
                  this.comicseasonForm.get('comic_series').setValue(singleadmin['comic_series']);
                  this.comicseasonForm.get('season_title').setValue(singleadmin['season_title']);
                  this.comicseasonForm.get('season_description').setValue(singleadmin['season_description']);
                  // this.comicseasonForm.get('seo_title').setValue(singleadmin['seo_title']);
                  // this.comicseasonForm.get('seo_description').setValue(singleadmin['seo_description']);
                  // this.comicseasonForm.get('seo_keyword').setValue(singleadmin['seo_keyword']);
                  this.comicseasonForm.get('sponsor_url').setValue(singleadmin['sponsor_url']);
                  this.comicseasonForm.get('season_quarter').setValue(singleadmin['season_quarter']);
                  this.comicseasonForm.get('status').setValue(singleadmin['status']);
                  this.comicseasonForm.get('season').setValue(singleadmin['season']);
                  this.comicseasonForm.get('about_author').setValue(singleadmin['about_author']);
                  this.comicseasonForm.get('author_name').setValue(singleadmin['author_name']);
                  this.comicseasonForm.get('IsAllowPointsPurchase').setValue(singleadmin['IsAllowPointsPurchase'] ? String(singleadmin['IsAllowPointsPurchase']): "false");
                  this.comicseasonForm.get('on_going_series').setValue(singleadmin['on_going_series'] ? singleadmin['on_going_series'] : 'false');
                  this.sponsor_image_url_web = singleseries['sponsor_banner_web'];
                  this.thumbnail_image_url = singleseries['thumbnail_image'];
                  this.cover_image_url = singleseries['cover_image'];
                  this.sponsor_image_url = singleseries['sponsor_image'];
                  this.status = true;
                  this.season = true;
                  this.showseries = true;
                  this.quater  = true;
                });
              });
            }
          });
        } else {
          this.comicseasonForm.get('comic_series').setValue(this.comics[0].id);
          this.showseries = true;
          if (!this.id) {
            this.auth.getuser().then(userdetails => {
              this.user = userdetails;
            });
          }
        }
      });
    });
  }

  async addseason(value, valid) {
    if (valid) {
      this.loading = true;
      const season: Season = {
        comic_series: value.comic_series,
        author_name: value.author_name,
        about_author: value.about_author,
        season_title: value.season_title,
        season_description: value.season_description,
        sponsor_url: value.sponsor_url,
        season_quarter: value.season_quarter,
        season: value.season,
        status: value.status,
        reads: 0,
        on_going_series:value.on_going_series
      };
      try {
        if (this.id) {
          let thumbnail;
          let coverimage;
          let sponsorimage;
          let sponsorbanner_web;
          // Checking if the cover image is changed if changed the update the image in sapces and also db.
          if (this.cover_image) {
            coverimage = await this.auth.uploadimage('comic/thumbnail/', this.cover_image, false);
            season.cover_image = coverimage['Location'];
          }
          // Checking if the thumbnail image is changed if changed the update the image in sapces and also db.
          if (this.thumbnail_image) {
            thumbnail = await this.auth.uploadimage('comic/cover/', this.thumbnail_image, false);
            season.thumbnail_image = thumbnail['Location'];
          }
          if (this.sponsor_image) {
            sponsorimage = await this.auth.uploadimage('sponser/', this.sponsor_image, false);
            season.sponsor_image = sponsorimage['Location'];
          }

          if (this.sponsor_image_web) {
            sponsorbanner_web = await this.auth.uploadimage('sponser/banner/', this.sponsor_image_web, false);
            season.sponsor_banner_web = sponsorbanner_web['Location'];
          }
          season.IsAllowPointsPurchase = JSON.parse(value.IsAllowPointsPurchase);
          const document = await this.afs.doc(`/Ecomicseason/${this.id}`);
          const update = await document.update(season);

          this.toastr.success('Ecomic Season Added!', 'Success!');
          this.router.navigate(['/comic-seasons']);
        } else {
          if (!this.thumbnail_image) { this.thumbnailimageerror = true; this.loading = false; return false; }
          if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
          if (!this.sponsor_image) { this.sponsorimageerror = true; this.loading = false; return false; }
          if (!this.sponsor_image_web) { this.sponsorimageerror_Web = true; this.loading = false; return false; }
          // uploading the images to the spaces and getting the uoloaded location
          const thumbnail = await this.auth.uploadimage('comic/thumbnail/', this.thumbnail_image, false);
          const coverimage = await this.auth.uploadimage('comic/cover/', this.cover_image, false);
          const sponsorimage = await this.auth.uploadimage('sponsor/', this.sponsor_image, false);
          const sponsorbanner_web = await this.auth.uploadimage('sponsor/banner/', this.sponsor_image_web, false);
          season.thumbnail_image = thumbnail['Location'];
          season.cover_image = coverimage['Location'];
          season.sponsor_image = sponsorimage['Location'];
          season.sponsor_banner_web = sponsorbanner_web['Location']
          season.pricing_type = 'Free';
          season.admin = this.user.uid;
          season.addedby = this.user.username;
          season.rating = [0, 0, 0, 0, 1];
          season.createdAt = new Date();
          season.date = new Date().toString();
          season.IsAllowPointsPurchase = JSON.parse(value.IsAllowPointsPurchase);
          console.log(season)
          const eseasondata = await this.afs.collection('Ecomicseason').add(season);
          const esid = eseasondata.id;
          const id = await this.afs.doc(`/Ecomicseason/${esid}`).update({ id: esid });

          this.router.navigate(['/comic-seasons']);
          this.toastr.success('Ecomic Season Added!', 'Success!');
        }
      } catch (error) {
        this.loading = false;
        this.load = true;
        this.toastr.error('Somthing went wrong please try later!', 'Oops!');
        console.log(error);
      }
    } else {
      console.log('error');
      this.toastr.error('Somthing went wrong please try later!', 'Oops!');
    }
  }

  changeListner1(event) {
    if (event.target.files && event.target.files[0]) {
      this.thumbnail_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.thumbnail_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeListner2(event) {
    if (event.target.files && event.target.files[0]) {
      this.cover_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.cover_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }


  changeListner3(event) {
    if (event.target.files && event.target.files[0]) {
      this.sponsor_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.sponsor_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }
  
  changeListner4(event) {
    if (event.target.files && event.target.files[0]) {
      this.sponsor_image_web = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.sponsor_image_url_web = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/E-comics/e-comic-season-add/e-comic-season-add.component.ts